/** @jsx jsx */
import React from 'react';
import { jsx, css, SerializedStyles } from '@emotion/react';
import { AppColors, Sizes } from 'styles/variables-slykit';

interface OuterProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	innerProps?: InnerProps
}
interface InnerProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	css?: SerializedStyles
}


export const ScrollBox: React.FunctionComponent<OuterProps> = ({ children, innerProps, ...props }) => {
	return (
		<div
			css={css`
				flex: 1 1 auto;
				overflow: hidden;
				display: flex;
				flex-direction: column;

				/* box-shadow: 
					inset 0px 16px 16px -16px rgba(0,0,0,0.1), 
					inset 0px 4px 4px -4px rgba(0,0,0,0.05),
					inset 0px -16px 16px -16px rgba(0,0,0,0.1); */

				/* SHADOWS */
				position: relative;
				&:before,
				&:after {
					content: '';
					position: absolute;
					height: ${Sizes.md};
					z-index: 1;
					pointer-events: none;
				}
				&:before {
					/* top shadow */
					background-image: linear-gradient(to bottom, ${AppColors.shadowGradient});
					top: 0;
					left: 0;
					right: 0;
				}
				&:after {
					/* bottom fade to white */
					background-image: linear-gradient(to top, ${AppColors.shadowGradient});
					bottom: -1px;
					left: 0;
					right: 0;
				}
			`}
			{...props}
		>
			<div
				{...innerProps}
				css={[css`
					overflow-y: auto;
					overflow-x: hidden; // no horizontal scroll
					height: 100%;
				`, innerProps?.css]}
			>
				{children}
				{/* <div css={css`min-height:600px; border-radius: 6px; background-color:lightgray; margin:2rem;`} /> // test... */}
			</div>
		</div>
	);
};

